module.exports = __webpack_public_path__ + "static/media/bg_01.5b36ce85.jpg";